import { useEffect, useCallback } from 'react';
import { useSpring } from 'framer-motion';

const springConfig = { damping: 100, mass: 2 };

export const useVec3 = (xyz, config) => {
	const x = useSpring(!!xyz ? xyz[0] : 0, config || springConfig);
	const y = useSpring(!!xyz ? xyz[1] : 0, config || springConfig);
	const z = useSpring(!!xyz ? xyz[2] : 0, config || springConfig);

	useEffect(() => {
		return () => {
			x.destroy();
			y.destroy();
			z.destroy();
		};
	}, [x, y, z]);

	const get = useCallback(() => [x.current, y.current, z.current], [x, y, z]);
	const getX = useCallback(() => x.current, [x]);
	const getY = useCallback(() => y.current, [y]);
	const getZ = useCallback(() => z.current, [z]);

	const set = useCallback(
		(xyz) => {
			x.set(xyz[0]);
			y.set(xyz[1]);
			z.set(xyz[2]);
		},
		[x, y, z]
	);

	const setX = useCallback((value) => x.set(value), [x]);
	const setY = useCallback((value) => y.set(value), [y]);
	const setZ = useCallback((value) => z.set(value), [z]);

	const destroy = useCallback(() => {
		x.destroy();
		y.destroy();
		z.destroy();
	}, [x, y, z]);

	return {
		get,
		getX,
		getY,
		getZ,
		set,
		setX,
		setY,
		setZ,
		destroy,
	};
};

export default useVec3;
